<template>
  <div>
    <div class="text-h6">Core Product</div>
    <v-btn
      text
      class="pl-0 mt-4"
      @click="back"
    >
      &lt; Back
    </v-btn>
    <v-row>
      <v-col
        cols="12"
        md="3"
      >
        <Edit @print="print_drawer = true" />
      </v-col>
      <v-col
        cols="12"
        md="9"
      >
        <Resize
          v-if="product.allowTemplateCreation"
          class="mb-6"
        />
        <Guides class="mb-6" />
        <Outputs class="mb-6" />
        <ResourceImages />
        <v-navigation-drawer
          v-model="print_drawer"
          temporary
          right
          width="100%"
          height="100%"
          app
        >
          <v-card
            flat
            class="px-4"
          >
            <v-card-title>
              {{ product.name }} Print Setup
              <v-spacer />
              <v-btn
                color="info"
                class="mr-4"
                target="_blank"
                :href="previewLink"
              >
                Preview
              </v-btn>
              <v-icon @click="print_drawer = false"> close </v-icon>
            </v-card-title>
            <v-card-text>
              <v-expansion-panels accordion>
                <Prints />
                <Options />
              </v-expansion-panels>
            </v-card-text>
          </v-card>
        </v-navigation-drawer>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Edit from '@/components/products/Edit';
import Guides from '@/components/products/Guides';
import Options from '@/components/products/Options';
import Outputs from '@/components/products/Outputs';
import Prints from '@/components/products/Prints';
import Resize from '@/components/products/Resize';
import ResourceImages from '@/components/products/ResourceImages';
import { mapGetters } from 'vuex';

export default {
  name: 'ProductsDetail',

  components: {
    Edit,
    Guides,
    Outputs,
    Prints,
    Resize,
    Options,
    ResourceImages
  },

  data() {
    return {
      print_drawer: false
    };
  },

  computed: {
    id() {
      return parseInt(this.$route.params.id);
    },
    previewLink() {
      return `${this.dashboard_url}admin/product-setup/category/${this.product?.category?.id}/products/${this.product?.id}`;
    },
    ...mapGetters({
      product: 'products/edit_product',
      dashboard_url: 'lookup/dashboard_url'
    })
  }
};
</script>
